import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import Outline from "../../Button/Outline/Index";
import SubMenu from "../../Header/Navbar/SubMenu";
import "../Navbar/Navbar.css";
import { NavLink, useLocation } from "react-router-dom"; 
import { Link } from "react-router-dom";

const Index = ({ menuData }) => {
  const location = useLocation(); // Get the current route path

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  const isActive = (href) => {
    return location.pathname === href; 
  };

  return (
    <div className="navbar gap-3 p-0">
      <div className="col-12 float-start d-flex justify-content-end gap-3">
     
        <Outline
          buttonText="Request a Quote"
          _class={"whitetextColor"}
          pageLink={"/request-quote"}
        />
        <div className={`button-container-1 redColor flex-center d-flex`}>
            <span className="col-12 flaot-start lh-1">Toll Free</span>
            <span className="col-12 flaot-start lh-1">+91-81467 88888</span>
          </div>
      </div>
      <div className="col-12 float-start navbarcolumn d-flex justify-content-end align-items-center">
        <div className="menuStrip">
          <ul className="d-flex">
          {menuData.map((menu, index) => {
  const url = menu.ext_url
    ? menu.ext_url
    : menu.slug
    ? `/${menu.slug}`
    : null;

  return (
    <li key={index}>
      <span
        data-aos="fade-in"
        data-aos-offset="100"
        data-aos-duration="500"
        data-aos-once="true"
        data-aos-easing="ease-in-sine"
      >
       {menu.ext_url ? (
  <a href={menu.ext_url} >
    {menu.name}
  </a>
) : (
  <NavLink to={menu.link}>
    {menu.name}
  </NavLink>
)}
      </span>

      {menu.submenus && (
        <SubMenu
          submenus={menu.submenus}
          showViewAllLink={menu.showViewAllLink}
        />
      )}
    </li>
  );
})}
            <li><Link to="/contact-us">Contact us</Link></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Index;
